<!-- <div class="form-page-wrapper"> -->
<div class="container container form-page-placement">
    <div class="col-md-6 col-sm-10 col-md-push-3 tablet-block container-padding">
        <div class="row">
            <div *ngIf="captureSuccess"  class="col-xs-12 bottom-spc-20">
                <div class="col-xs-5 col-xs-offset-3 col-md-3 col-md-offset-4">
                    <img class="loan-confirm-img img-responsive" src="./assets/img/svg/loan_commercials-01.svg">
                </div>
                <h2 class="heading-style bottom-spc-10 col-xs-12 text-center">Your Official Email has been verified succesfully.</h2>
                <!-- <h2 class="heading-style bottom-spc-10 col-xs-12 text-center" *ngIf="consentType !== 'APPROVAL_MAIL'"> You are all done.</h2>
                <div class="col-xs-12 text-center" *ngIf="consentType !== 'APPROVAL_MAIL'">Our sales representative will get in touch with you if any further action is required.</div> -->
            </div>
            <div *ngIf="isBusinessError"  class="col-xs-12 bottom-spc-20">
                <div class="col-xs-5 col-xs-offset-3 col-md-3 col-md-offset-4">
                    <img class="loan-confirm-img img-responsive" src="./assets/img/svg/loan_commercials-01.svg">
                </div>
                <h2 class="heading-style bottom-spc-10 col-xs-12 text-center"> {{errorMessage}}</h2>
                <div class="col-xs-12 text-center">Please check the latest sms/email from us to verify your email.</div>
            </div>
            <div *ngIf="isError" class="col-xs-12 bottom-spc-20 text-center">
                <img class="loan-confirm-img" src="./assets/img/svg/loan_commercials-02.svg">

                <h2 class="heading-style bottom-spc-10"> Unable to verify your email</h2>
                <div>Please check the latest sms/email from us to verify your email.</div>
            </div>
        </div>
    </div>
    <!-- </div>
</div> -->